import { z } from 'zod';

export const programSchema = z.enum(['v5rc', 'viqrc', 'vurc', 'vairc', 'unknown']);
export type Program = z.infer<typeof programSchema>;

export const verifiedStatusSchema = z.enum(['unverified', 'verified', 'admin_curated']);
export type VerifiedStatus = z.infer<typeof verifiedStatusSchema>;

export const teamSchema = z.object({
  id: z.uuid(),
  teamNumber: z.string().min(1).max(16),
  teamName: z.string(),
  organization: z.string().nullable(),
  program: programSchema,
  gradeLevel: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  country: z.string().nullable(),
  countrySlug: z.string().nullable(),
  citySlug: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  robotEventsTeamId: z.string().nullable(),
  websiteUrl: z.url().nullable(),
  socialLinks: z.record(z.string(), z.url()).nullable(),
  bio: z.string().nullable(),
  verifiedStatus: verifiedStatusSchema,
  hasStory: z.boolean(),
  lastSyncedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type Team = z.infer<typeof teamSchema>;

export const teamSummarySchema = teamSchema.pick({
  teamNumber: true,
  teamName: true,
  organization: true,
  program: true,
  city: true,
  region: true,
  country: true,
  countrySlug: true,
  citySlug: true,
  hasStory: true,
});
export type TeamSummary = z.infer<typeof teamSummarySchema>;

export const globePointSchema = z.object({
  teamNumber: z.string(),
  lat: z.number(),
  lon: z.number(),
  program: programSchema,
  eventCode: z.string().nullable(),
});
export type GlobePoint = z.infer<typeof globePointSchema>;

export const globeClusterSchema = z.object({
  citySlug: z.string(),
  city: z.string(),
  country: z.string(),
  countrySlug: z.string(),
  lat: z.number(),
  lon: z.number(),
  teamCount: z.number().int(),
  programBreakdown: z.record(programSchema, z.number().int()),
});
export type GlobeCluster = z.infer<typeof globeClusterSchema>;
